import { getToken, setToken } from '@/utils/auth'

const state = {
  xyOriginBool: false,
  yxyOriginBool: false,
  qtOriginBool: false,
  token: getToken(),
  orgId:'',
  examId:'',
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ORGID:(state,orgId)=>{
    console.log(orgId);
    
    state.orgId = orgId
  },
  SET_EXAMID:(state,examId)=>{
    console.log(examId);
    
    state.examId = examId
  },
  SET_XYORIGINBOOL: (state, xyOriginBool) => {
    state.xyOriginBool = xyOriginBool
  },
  SET_YXYORIGINBOOL: (state, yxyOriginBool) => {
    state.yxyOriginBool = yxyOriginBool
  },
  SET_QTORIGINBOOL: (state, qtOriginBool) => {
    state.yxyOriginBool = qtOriginBool
  },
}

const actions = {
  // user login
  login({ commit }, token) {
    commit('SET_TOKEN', token)
        setToken(token)
  },
  // setFrom({ commit }, from) {
  //   console.log(commit)
  //   commit('SET_FROM', from)
  // },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
